import { Chip, Grid } from "@mui/material";
import React from "react";
import { icons } from "../../../../../constants";

const FilterSection = ({
  handleFilterModalOpen,
  statusFilterOptions,
  roleFilterOptions,
  dateAddedFilterOptions,
  lastLoginDateFilterOptions,
  handleDeleteChip,
}) => {
  return (
    <Grid
      container
      style={{ marginTop: 20, marginBottom: 20 }}
      alignItems={"center"}
    >
      <img
        src={icons.FilterIcon}
        alt="filter icon"
        onClick={handleFilterModalOpen}
        style={filterIconStyles}
      />{" "}
      <span onClick={handleFilterModalOpen} style={filterTextStyles}>
        Filters
      </span>
      {statusFilterOptions.map((filterItem, index) => (
        <Chip
          label={filterItem}
          key={index}
          style={selectedChipStyles}
          onDelete={() => handleDeleteChip("status", filterItem)}
        />
      ))}
      {roleFilterOptions.map((filterItem, index) => (
        <Chip
          label={filterItem}
          key={index}
          style={selectedChipStyles}
          onDelete={() => handleDeleteChip("role", filterItem)}
        />
      ))}
      {lastLoginDateFilterOptions.map((filterItem, index) => (
        <Chip
          label={filterItem}
          key={index}
          style={selectedChipStyles}
          onDelete={() => handleDeleteChip("lastLoginDate", filterItem)}
        />
      ))}
      {dateAddedFilterOptions.map((filterItem, index) => (
        <Chip
          label={filterItem}
          key={index}
          style={selectedChipStyles}
          onDelete={() => handleDeleteChip("dateAdded", filterItem)}
        />
      ))}
    </Grid>
  );
};

export default FilterSection;

const filterIconStyles = {
  height: 35,
  width: 30,
  marginLeft: 16,
  cursor: "pointer",
};

const filterTextStyles = {
  color: "#00A7CD",
  fontSize: 14,
  fontWeight: 500,
  cursor: "pointer",
  fontFamily: "Avenir Book, sans-serif",
  textTransform: "capitalize",
};

const selectedChipStyles = {
  marginRight: 10,
  fontWeight: 500,
  fontSize: 14,
  backgroundColor: "#00A7CD",
  paddingLeft: 10,
  paddingRight: 10,
  cursor: "pointer",
  color: "#fff",
  marginLeft: 5,
  fontFamily: "Avenir Book, sans-serif",
  textTransform: "capitalize",
};
